import gql from 'graphql-tag';

export default gql`
  query courseLearningNotes($ids: [String!]!) {
      courseLearningNotes(ids: $ids) {
        id
        noteTitle
        noteContent
        selectValue
      }
  }
`;
